import breakPoints from "./breakPoints";
const MediaQueries = {
    desktop: `@media(min-width:${breakPoints.mobile}px)`
};
export default MediaQueries;
//# sourceMappingURL=MediaQueries.js.map